import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import CategoryPage from "./CategoryPage";

const ITEMS = [
  {
    slug: "guide",
    to: "/prodotti/risorse/guide",
    label: "Guide",
    desc: "Passaggi chiari per orientarsi e agire.",
  },
  {
    slug: "manuali",
    to: "/prodotti/risorse/manuali",
    label: "Manuali",
    desc: "Riferimenti completi per approfondire un tema.",
  },
  {
    slug: "dossier",
    to: "/prodotti/risorse/dossier",
    label: "Dossier",
    desc: "Analisi verticali su temi specifici.",
  },
];

export default function RisorsePage() {
  return (
    <div>
      <div className="px-5 sm:px-8 lg:px-12 pt-20 max-w-6xl mx-auto">
        <Link
          to="/prodotti"
          data-testid="risorse-back-link"
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition"
        >
          <ChevronLeft className="w-3.5 h-3.5" />
          Torna a Prodotti
        </Link>
      </div>
      <div className="-mt-10">
        <CategoryPage
          eyebrow="Prodotti · Risorse"
          title="Risorse."
          description="Guide, manuali e dossier per approfondire, decidere e agire."
          items={ITEMS}
          testId="risorse"
        />
      </div>
    </div>
  );
}
